import { useState } from 'react'
import styled from 'styled-components'

import { DateHelper, DatePicker, Select } from '@loadsmart/loadsmart-ui'
import { type Selectable } from '@loadsmart/loadsmart-ui/dist/hooks/useSelectable'
import { Divider, Drawer, Field, Icon, LabeledValue, Layout, Text } from '@loadsmart/miranda-react'

import { formatNewSchedule } from '../../presenters/openDockAppointmentPresenter'
import { ScheduleTimeList } from '../ScheduleTimeList/ScheduleTimeList'

const DatePickerWrapper = styled.div`
  [role='menubar'] {
    div:nth-child(1) {
      flex: 1;
    }
  }
`

const MOCK_DOCK_OPTIONS = [
  { label: 'Dock A', value: 'dock_a' },
  { label: 'Dock B', value: 'dock_b' },
  { label: 'Dock C', value: 'dock_c' },
  { label: 'Dock D', value: 'dock_d' },
]

const MOCK_TIME_SLOTS = [
  '8:00',
  '9:30',
  '10:00',
  '10:30',
  '11:00',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
]

export function Reschedule({
  onReschedule,
  onBack,
  onCancelAppointment,
  facilityTimezone,
}: {
  onReschedule: () => void
  onBack: () => void
  onCancelAppointment: () => void
  facilityTimezone?: string
}) {
  const [selectedDock, setSelectedDock] = useState<Selectable | null>(null)
  const [selectedHour, setSelectedHour] = useState<string | null>(null)
  const [appointmentDate, setAppointmentDate] = useState<string | null>(DateHelper().toString())

  const disableSubmit = !selectedDock || !selectedHour || !appointmentDate
  const newScheduleLabel = formatNewSchedule(appointmentDate, selectedHour, facilityTimezone)

  return (
    <>
      <Drawer.Header>
        <Layout.Group align="center" gap="spacing-1">
          <Icon name="calendar" size="24px" />
          Reschedule
        </Layout.Group>
        <Drawer.Close />
      </Drawer.Header>
      <Drawer.Body>
        <Layout.Stack gap="spacing-4" paddingB="spacing-2">
          <LabeledValue>
            <LabeledValue.Label>Warehouse</LabeledValue.Label>
            <LabeledValue.Value>TO DO</LabeledValue.Value>
          </LabeledValue>
          <LabeledValue>
            <LabeledValue.Label>Load type</LabeledValue.Label>
            <LabeledValue.Value>TO DO</LabeledValue.Value>
          </LabeledValue>
          <Field label="Docks" size="small">
            <Select
              name="dock"
              placeholder="Select dock"
              options={MOCK_DOCK_OPTIONS}
              value={selectedDock}
              onChange={({ target }) => setSelectedDock(target.value as Selectable | null)}
              hideClear
            />
          </Field>
          <LabeledValue>
            <LabeledValue.Label>Scheduled At</LabeledValue.Label>
            <LabeledValue.Value>TO DO</LabeledValue.Value>
          </LabeledValue>
          <Divider />
          <Field label="New appointment date" size="small">
            <DatePickerWrapper>
              <DatePicker
                name="appointmentDate"
                value={appointmentDate}
                onChange={({ target }) => setAppointmentDate(target.value)}
                constraints={[[null, DateHelper().subtract('day', 1).toString()]]}
              />
            </DatePickerWrapper>
          </Field>
          <ScheduleTimeList
            label={
              <Text variant="body-sm" color="color-text-tertiary">
                New hour
              </Text>
            }
            timeSlots={MOCK_TIME_SLOTS}
            value={selectedHour}
            setValue={setSelectedHour}
            validationStatus="default"
            errorMessage={undefined}
          />
          <Divider />
          <Layout.Box
            paddingY="spacing-4"
            paddingX="spacing-6"
            borderWidth="border-thin"
            borderRadius="border-radius-m"
            borderColor="color-border-input"
          >
            <Layout.Stack gap="spacing-1">
              <Text variant="body-md-bold">Once you confirm, your changes will be saved</Text>
              {newScheduleLabel && (
                <Text
                  variant="body-sm"
                  color="color-text-tertiary"
                  style={{ wordBreak: 'break-all' }}
                >
                  {newScheduleLabel}
                </Text>
              )}
            </Layout.Stack>
          </Layout.Box>
        </Layout.Stack>
      </Drawer.Body>
      <Drawer.Actions>
        <Drawer.ActionTertiary
          style={{ marginRight: 'auto' }}
          leading=<Icon name="arrow-left" />
          onClick={onBack}
        >
          Back
        </Drawer.ActionTertiary>
        <Drawer.ActionPrimary disabled={disableSubmit} onClick={onReschedule}>
          Confirm
        </Drawer.ActionPrimary>
      </Drawer.Actions>
    </>
  )
}
